exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my404component-cssmodule-my404component-component-2hdkL{margin-top:50px}.my404component-cssmodule-error-template-3x7AP{text-align:center}", ""]);

// exports
exports.locals = {
	"my404component-component": "my404component-cssmodule-my404component-component-2hdkL",
	"error-template": "my404component-cssmodule-error-template-3x7AP"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/404/my404component.cssmodule.scss
// module id = 596
// module chunks = 0